// Assuming aianta.ImagePreloader are globally available
// or imported elsewhere if they are modules. If they are modules, add imports:
import IsoFilter from "./IsoFilter"; // Import the new module
// import ImagePreloader from './path/to/ImagePreloader'; // Example
// import Swipermodel from './path/to/Swipermodel'; // Example
function initializeItineraryIndex() {
  console.log("iitinerary.js loadedd");

  document
    .querySelectorAll(
      ".region_header_opened, .theme_header_opened, .days_header_opened"
    )
    .forEach((el) => (el.style.display = "none"));
  document.dispatchEvent(new CustomEvent("isofilter-model:ready"));
  document.dispatchEvent(new CustomEvent("image-preloader:ready"));

  let stackedFilters;
  let regionDropdownOpen = false;
  let themeDropdownOpen = false;
  let daysDropdownOpen = false;

  if (window.innerWidth < 768) {
    stackedFilters = true;
  } else {
    stackedFilters = false;
  }

  // Get references to specific elements ONCE
  const regionWrapper = document.querySelector(".region-filter-wrapper");
  const regionDropdown = regionWrapper?.querySelector(
    ".itinerary-filter-dropdown.region_header_opened"
  );
  const regionArrowUp = regionWrapper?.querySelector(
    ".itinerary-filter-arrows .region_header_opened"
  );
  const regionArrowDown = regionWrapper?.querySelector(
    ".itinerary-filter-arrows .region_header_closed"
  );

  const themeWrapper = document.querySelector(".theme-filter-wrapper");
  const themeDropdown = themeWrapper?.querySelector(
    ".itinerary-filter-dropdown.theme_header_opened"
  );
  const themeArrowUp = themeWrapper?.querySelector(
    ".itinerary-filter-arrows .theme_header_opened"
  );
  const themeArrowDown = themeWrapper?.querySelector(
    ".itinerary-filter-arrows .theme_header_closed"
  );

  const daysWrapper = document.querySelector(".days-filter-wrapper");
  const daysDropdown = daysWrapper?.querySelector(
    ".itinerary-filter-dropdown.days_header_opened"
  );
  const daysArrowUp = daysWrapper?.querySelector(
    ".itinerary-filter-arrows .days_header_opened"
  );
  const daysArrowDown = daysWrapper?.querySelector(
    ".itinerary-filter-arrows .days_header_closed"
  );

  // Ensure elements are hidden initially (like the old .hide())
  // We might need to run this logic once on load if CSS doesn't hide them by default
  [
    regionDropdown,
    regionArrowUp,
    themeDropdown,
    themeArrowUp,
    daysDropdown,
    daysArrowUp,
  ].forEach((el) => {
    if (el && getComputedStyle(el).display !== "none") {
      el.style.display = "none";
    }
  });

  const toggleDisplay = (element) => {
    if (!element) return;
    element.style.display =
      element.style.display === "none" || element.style.display === ""
        ? "block" // Or maybe "inline-block" for arrows?
        : "none";
  };

  const regionDropdownToggle = () => {
    if (regionWrapper) regionWrapper.classList.toggle("opened");
    toggleDisplay(regionDropdown);
    toggleDisplay(regionArrowUp);
    toggleDisplay(regionArrowDown);
    regionDropdownOpen = !regionDropdownOpen;
  };

  const themeDropdownToggle = () => {
    if (themeWrapper) themeWrapper.classList.toggle("opened");
    toggleDisplay(themeDropdown);
    toggleDisplay(themeArrowUp);
    toggleDisplay(themeArrowDown);
    themeDropdownOpen = !themeDropdownOpen;
  };

  const daysDropdownToggle = () => {
    if (daysWrapper) daysWrapper.classList.toggle("opened");
    toggleDisplay(daysDropdown);
    toggleDisplay(daysArrowUp);
    toggleDisplay(daysArrowDown);
    daysDropdownOpen = !daysDropdownOpen;
  };

  const closeOpenDropdowns = () => {
    if (regionDropdownOpen) {
      regionDropdownToggle();
    }
    if (themeDropdownOpen) {
      themeDropdownToggle();
    }
    if (daysDropdownOpen) {
      daysDropdownToggle();
    }
  };

  const regionDropdownButton = document.getElementById("region-dropdown");
  if (regionDropdownButton) {
    regionDropdownButton.addEventListener("click", () => {
      const currentState = regionDropdownOpen;
      if (stackedFilters) {
        closeOpenDropdowns();
        if (!currentState) {
          regionDropdownToggle();
        }
      } else {
        regionDropdownToggle();
      }
    });
  }

  const themeDropdownButton = document.getElementById("theme-dropdown");
  if (themeDropdownButton) {
    themeDropdownButton.addEventListener("click", () => {
      const currentState = themeDropdownOpen;
      if (stackedFilters) {
        closeOpenDropdowns();
        if (!currentState) {
          themeDropdownToggle();
        }
      } else {
        themeDropdownToggle();
      }
    });
  }

  const daysDropdownButton = document.getElementById("days-dropdown");
  if (daysDropdownButton) {
    daysDropdownButton.addEventListener("click", () => {
      const currentState = daysDropdownOpen;
      if (stackedFilters) {
        closeOpenDropdowns();
        if (!currentState) {
          daysDropdownToggle();
        }
      } else {
        daysDropdownToggle();
      }
    });
  }

  // --- Isotope/Image Logic ---
  const isoContainer = document.getElementById("iso-container");

  // Define renderIsofilter first (needs to be available before direct call)
  const renderIsofilter = () => {
    if (!isoContainer) return; // Add guard clause here too

    // Ensure aianta namespace is available globally or imported
    // Assuming aianta.IsoFilter exists and doesn't require jQuery internally
    const filterOptions = {
      itemClass: ".card-item",
      usaMap: "none",
    };
    // Use the imported IsoFilter class
    const isofilter = new IsoFilter(isoContainer, filterOptions);
    console.log("IsoFilter instance created:", isofilter);

    // Use Event Delegation on a parent container
    const filtersContainer = document.querySelector(".itinerary-filters");
    console.log("check if filtersContainer exists", filtersContainer);
    if (filtersContainer) {
      filtersContainer.addEventListener("click", (e) => {
        // Check if the clicked element *is* a filterbox link
        const link = e.target.closest(".filterbox-links");
        if (!link) return; // Click wasn't on a filter link or its child

        console.log("Filter link clicked (delegated):", link); // Log 1
        e.preventDefault();
        const linkActive = link.getAttribute("data-activelink");
        const filterValue = link.dataset.filter; // Access data-* attributes
        console.log("Filter:", filterValue, "Active:", linkActive); // Log 2

        if (!filterValue) {
          console.error("Link missing data-filter attribute:", link);
          return;
        }

        // Determine filter type (Example: check parent container)
        let filterType = "category"; // Default assumption
        if (link.closest(".region-filter-wrapper")) {
          filterType = "region";
        } else if (link.closest(".theme-filter-wrapper")) {
          filterType = "category"; // Or 'theme' if you want separate logic
        } else if (link.closest(".days-filter-wrapper")) {
          filterType = "category"; // Or 'days' if you want separate logic
        }
        console.log("Filter type:", filterType); // Log 3

        if (linkActive === "true") {
          // Deactivate filter
          link.classList.remove("active");
          link.setAttribute("data-activelink", "false");
          if (filterType === "region") {
            console.log("Removing region filter:", filterValue);
            isofilter.removeRegionFilter(filterValue);
          } else {
            // Assuming theme/days are treated as categories
            console.log("Removing category filter:", filterValue);
            isofilter.removeCategoryFilter(filterValue);
          }
          // TODO: Maybe remove from link watcher here?
        } else {
          // Activate filter
          link.classList.add("active");
          link.setAttribute("data-activelink", "true");
          if (filterType === "region") {
            console.log("Adding region filter:", filterValue);
            isofilter.addRegionFilter(filterValue);
          } else {
            // Assuming theme/days are treated as categories
            console.log("Adding category filter:", filterValue);
            isofilter.addCategoryFilter(filterValue);
          }
          isofilter.addLinkWatcher(link); // TODO: Only add when activating?
        }
        console.log("Calling setFilters"); // Log 4
        isofilter.setFilters(); // Assuming this method exists
      });
    } else {
      console.warn(
        ".itinerary-filters container not found for event delegation."
      );
    }
  }; // End of renderIsofilter definition

  // Check if container exists before attempting Isotope logic
  if (isoContainer) {
    // TODO: Deal with aianta.ImagePreloader later
    console.log("Bypassing ImagePreloader, calling renderIsofilter directly.");
    renderIsofilter(); // Call directly to test listener attachment

    /* --- Temporarily comment out ImagePreloader logic ---
    const isoContainerImages = isoContainer.querySelectorAll("img"); // Find images within the container
    if (isoContainerImages.length > 0) {
      // Assuming aianta.ImagePreloader exists and takes a standard NodeList or Array
      // Ensure aianta namespace is available globally or imported
      const bodyImagePreloader = new aianta.ImagePreloader(document.body);
      const imagesSrc = Array.from(isoContainerImages).map((img) =>
        img.getAttribute("src")
      );
      console.log("imagesSrc", imagesSrc);
      bodyImagePreloader.process(imagesSrc, renderIsofilter); // Assuming this method exists
    } else {
      // If no images, maybe still render isofilter for empty state?
      console.log("No images found in #iso-container, attempting to render filter anyway.");
      renderIsofilter(); 
    }
    */ // --- End commented out ImagePreloader logic ---
  } // End of if (isoContainer)
  // --- End Isotope/Image Logic ---
}

function initializeItineraryShow() {
  // Assuming aianta.Swipermodel exists and doesn't require jQuery internally
  // Ensure aianta namespace is available globally or imported
  const swiper = new aianta.Swipermodel({ slideChangeAnimation: false });
  swiper.setupSwiper(); // Assuming this method exists
  swiper.setupListener(); // Assuming this method exists
}

// Attach event listeners using standard browser APIs
document.addEventListener("turbolinks:load", () => {
  console.log("turbolinks:load event fired FIRED");

  // Check if we are on the Itineraries Index page by looking for the data attribute
  if (document.querySelector('[data-page="itineraries-index"]')) {
    console.log("Initializing itinerary index JS...");
    initializeItineraryIndex();
  }

  // Check if we are on the Itineraries Show page
  // NOTE: You'll need to add data-page="itineraries-show" to the main container
  // on the show page template for this to work.
  if (document.querySelector('[data-page="itineraries-show"]')) {
    console.log("Initializing itinerary show JS...");
    initializeItineraryShow();
  }
});

// Optional: Export functions if they need to be called directly from elsewhere
// export { initializeItineraryIndex, initializeItineraryShow };
